import * as THREE from 'three';

import { BAcisiUst } from './bAcisiUst';
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js'
import { CAcisiAlt } from './cAcisiAlt';
import { FikoProfil2d } from '../../IFikoThreeJS/FikoThreeCam/FikoProfil2d';
import { FikoCizimler } from '../../IFikoThreeJS/FikoThreeCam/FikoCizimler';
import { FikoKaynakca } from '../../IFikoThreeJS/FikoThreeCam/FikoKaynakca';
import { Fiko3DIsaretleyiciler } from '../../IFikoThreeJS/Fiko3DIsaretleyiciler';
import { FikoIsiklar } from '../../IFikoThreeJS/FikoIsiklar';
import { FikoTakimFrezeleme } from '../../IFikoThreeJS/FikoThreeCam/FikoTakimFrezeleme';
import { FikoThreeJsComponent } from '../../fiko-three-js.component';
import { FikoSahne } from '../../IFikoThreeJS/FikoSahne';
import { FikoImporterWRL } from '../../IFikoThreeJS/FikoImporter.WRL';
import { FikoEksen } from '../../IFikoThreeJS/FikoEksen';
import { FikoVektor3D } from '../../IFikoThreeJS/FikoVektor3d';
import { FikoCizimYalin } from '../../IFikoThreeJS/FikoCizimYalin';
import { FikoObje3D } from '../../IFikoThreeJS/FikoObje3D';
import { FikoIsikOrtam } from '../../IFikoThreeJS/FikoIsikOrtam';
declare var TWEEN: any;

export class SahneWtecKafa extends FikoSahne {
    fikoProfil2d: FikoProfil2d = new FikoProfil2d();
    //** */
    // islemeEkseni: FikoEksen;
    /** NOT: Standart Gruplar */
    // operasyonlar: FikoOperasyonlar;
    cizimler: FikoCizimler;
    kaynakca: FikoKaynakca;
    kaynakcaIsaretleyiciler: Fiko3DIsaretleyiciler;
    kaynakcaIsiklar: FikoIsiklar;
    /** */
    BAcisi: BAcisiUst;
    CAcisi: CAcisiAlt;
    takim: FikoTakimFrezeleme;

    // PERFORMANS: Reusable objeler - her seferinde yeni nesne yaratmayı önle
    private readonly _tempVec3_1 = new THREE.Vector3();
    private readonly _tempVec3_2 = new THREE.Vector3();
    private readonly _tempQuat = new THREE.Quaternion();
    private _isAnimating = false;
    private _rafId: number | null = null;

    constructor(public override anaGosterim: FikoThreeJsComponent) {
        super(anaGosterim);
        //--->
        const importer = new FikoImporterWRL(this);
        // this.operasyonlar = new FikoOperasyonlar(this, "FikoYT Operasyonlar");
        this.cizimler = new FikoCizimler(this, "FikoYT Diagonal Kafa");

        // this.cizimler.applyQuaternion(new THREE.Quaternion().setFromAxisAngle(new FikoVektor3D(0, 0, 1), degToRad(90)));
        // this.cizimler.setRotationFromAxisAngle(new FikoVektor3D(0, 0, 1), degToRad(90));
        //--->
        let eksen = new FikoEksen(this, "Eksen.1")
        this.cizimler.ekle(eksen);


        this.BAcisi = new BAcisiUst(this, "B Açısı Üst.1");


        this.CAcisi = new CAcisiAlt(this, "C Açısı Alt.1")
        this.BAcisi.ekle(this.CAcisi);

        this.cizimler.ekle(this.BAcisi);

        this.takim = new FikoTakimFrezeleme(this, 3, 1.5, 30, 15);

        var myDirectionVector = new FikoVektor3D(0, 0, 1);
        // myDirectionVector.transformDirection(islemeEkseni.matrixWorld);
        var mx = new THREE.Matrix4().lookAt(myDirectionVector, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, 1));
        var qt = new THREE.Quaternion().setFromRotationMatrix(mx);
        this.takim.quaternion.copy(qt);



        this.cizimler.ekle(this.takim);
        // this.cizimler.position.applyQuaternion(this.quaternion.clone().setFromAxisAngle(new FikoVektor3D(0, 0, 1), degToRad(270)));
        // this.cizimler.setRotationFromAxisAngle(new FikoVektor3D(0, 0, 1), degToRad(270));
        //  this.cizimler.ekle(new Fiko3DYazi(this.sahne, "Fiko\nYT"))


        // let makineSabitGovde = new FikoCizimWRL(this, "Makine Sabit Gövde");
        // makineSabitGovde.urlden("/makineler/makine-1/makine_sabit_govde.FikoCizim")
        // //--->
        // let makineBoruSurucu = new FikoImporter(this.cizimler).(this, "Makine Boru Sürücü");
        // makineBoruSurucu.urlden("/makineler/makine-1/Boru_Surucu.FikoCizim")
        //--->
        // this.cizimler.ekle(makineSabitGovde);
        // this.cizimler.ekle(makineBoruSurucu);
        /** */

        /** */
        this.kaynakca = new FikoKaynakca(this, "FikoYT Kaynakça");

        /** */
        this.kaynakcaIsiklar = new FikoIsiklar(this, "Fiko Işıklar");
        let anaOrtamIsigi = new FikoIsikOrtam(this, "Fiko Ana Ortam Işığı.1");
        anaOrtamIsigi.intensity = 1.5;
        this.kaynakcaIsiklar.ekle(anaOrtamIsigi);

        // let anaYonselIsik = new FikoIsikYonsel(this, "Fiko Ana Yönsel Işık.1");
        // anaYonselIsik.intensity = 2.5;
        // this.kaynakcaIsiklar.ekle(anaYonselIsik);

        // this.anaGosterim.aktifKontrol.addEventListener("change", (event: any) => {
        //     anaYonselIsik.position.copy(this.anaGosterim.aktifKamera.position);
        //     anaYonselIsik.matrix.copy(this.anaGosterim.aktifKamera.matrix);
        //     this.anaGosterim.ciz()
        // });

        this.kaynakca.ekle(this.kaynakcaIsiklar);
        /** */
        // this.kaynakcaIsaretleyiciler = new Fiko3DIsaretleyiciler(this, "İşaretçiler");
        // this.kaynakca.ekle(this.kaynakcaIsaretleyiciler);
        // let yazi = this.kaynakcaIsaretleyiciler.ekleFikoIsaretci("Hassas İşlem Yüzeyi");
        // yazi.hazirla();
        // // yazi.yazi3d.yazi = "Hassas Delik.1";
        // yazi.translateX(20);
        // yazi.translateY(-75);
        // yazi.translateZ(-75);
        /**  */

        // this.ekle(new THREE.AmbientLightProbe(0xffffff, 0.2));

        // this.add(this.operasyonlar);
        this.urunAgaci.add(this.cizimler);
        this.urunAgaci.add(this.kaynakca);
        /** */
        let kameraListe = [
            {
                "ismi": "Fikonum.1",
                "aciklama": null,
                "veri": {
                    "matriks": [
                        0.9489117946878672,
                        -0.30917425566533685,
                        -0.06306889515471081,
                        0,
                        0.17596955191928154,
                        0.3525978373444969,
                        0.9190807809421928,
                        0,
                        -0.2619181603088611,
                        -0.8832247985274013,
                        0.38898950187203396,
                        0,
                        15.733069172398999,
                        -81.9926483106101,
                        -222.30268351687866,
                        1
                    ],
                    "hedef": [
                        41.81702056154851,
                        5.966096830670189,
                        -261.0414378123224
                    ],
                    "position": [
                        15.733069172398999,
                        -81.9926483106101,
                        -222.30268351687866
                    ],
                    "quaternion": [
                        0.5493915851811293,
                        -0.060614645063292595,
                        -0.14788498050822288,
                        0.8201370516420409
                    ],
                    "scale": [
                        1,
                        1,
                        1
                    ],
                    "ust": [
                        0.1744576994614661,
                        0.3475036547131598,
                        0.9213065293697451
                    ],
                    "yakinlik": 0.2399115841046646,
                    "oran": 1.3526315789473684
                }
            },
            {
                "ismi": "Fikonum.2",
                "aciklama": null,
                "veri": {
                    "matriks": [
                        -0.12338695934895938,
                        -0.9751440184439206,
                        0.1840375004059255,
                        0,
                        0.8005909865960048,
                        0.011766040209277406,
                        0.5990956789019841,
                        0,
                        -0.5863699603866606,
                        0.22125935819945894,
                        0.7792397358742107,
                        0,
                        -454.90914538448715,
                        12.752307307394664,
                        117.77601577245551,
                        1
                    ],
                    "hedef": [
                        -396.27214934582156,
                        -9.373628512551045,
                        39.85204218503506
                    ],
                    "position": [
                        -454.90914538448715,
                        12.752307307394664,
                        117.77601577245551
                    ],
                    "quaternion": [
                        0.1462935956967635,
                        -0.2982923329906529,
                        -0.6875428450311102,
                        0.6456815811091657
                    ],
                    "scale": [
                        1,
                        1,
                        1
                    ],
                    "ust": [
                        0.8005909865959884,
                        0.011766040209277965,
                        0.5990956789019755
                    ],
                    "yakinlik": 0.5404056700055176,
                    "oran": 2.591093117408907
                }
            },
            {
                "ismi": "Fikonum.3",
                "aciklama": null,
                "veri": {
                    "matriks": [
                        -0.933089539913428,
                        0.35502167272810825,
                        0.05747627682342607,
                        0,
                        -0.22672264183962385,
                        -0.7047249783253866,
                        0.6722793679725304,
                        0,
                        0.279178713696816,
                        0.6142656728302659,
                        0.7380629573423747,
                        0,
                        -1525.8337707656012,
                        386.5793780687326,
                        281.14553721970447,
                        1
                    ],
                    "hedef": [
                        -1553.7516421352818,
                        325.1528107857082,
                        207.33924148546967
                    ],
                    "position": [
                        -1525.8337707656012,
                        386.5793780687326,
                        281.14553721970447
                    ],
                    "quaternion": [
                        0.09161397419278342,
                        0.3501076992318459,
                        0.9186780550852933,
                        0.15831016952770274
                    ],
                    "scale": [
                        1,
                        1,
                        1
                    ],
                    "ust": [
                        -0.22672264183961535,
                        -0.7047249783253604,
                        0.6722793679725051
                    ],
                    "yakinlik": 0.29469907358098063,
                    "oran": 2.591093117408907
                }
            },
            {
                "ismi": "Fikonum.4",
                "aciklama": null,
                "veri": {
                    "matriks": [
                        0.12428119377233271,
                        0.9879208713006911,
                        0.09255558828621391,
                        0,
                        -0.6234168169954588,
                        0.005174819172593548,
                        0.7818725558131462,
                        0,
                        0.7719492581522275,
                        -0.1548727648588163,
                        0.6165296177339832,
                        0,
                        -155.92028044518992,
                        12.018515862134628,
                        86.40267493344317,
                        1
                    ],
                    "hedef": [
                        -233.1152062604091,
                        27.50579234801554,
                        24.749713160047683
                    ],
                    "position": [
                        -155.92028044518992,
                        12.018515862134628,
                        86.40267493344317
                    ],
                    "quaternion": [
                        0.3544632409946608,
                        0.2570817028039324,
                        0.6097281371211798,
                        0.6606787477055148
                    ],
                    "scale": [
                        1,
                        1,
                        1
                    ],
                    "ust": [
                        -0.6234168169954316,
                        0.005174819172593773,
                        0.7818725558131068
                    ],
                    "yakinlik": 0.7107798400456625,
                    "oran": 2.591093117408907
                }
            }
        ]

        for (let i = 0; i < kameraListe.length; i++) {
            const element = kameraListe[i];
            this.kaynakca.konumlar.kaydet(element.ismi, element.aciklama, element.veri)
        }

        /** */
        this.cizimler.userData['FikoParametreler'] = [

        ];

        // setTimeout(() => { this.simuleEt() }, 5000);
        this.guncelle();
        this.anaGosterim.FikoYT.degisti.emit();


        // PERFORMANS: Timeout cascade yerine Promise chain + requestAnimationFrame
        setTimeout(async () => {
            await this.kaynakca.konumlar.liste[0].git(1000);

            // PERFORMANS: İç içe setTimeout yerine tek bir setTimeout
            await new Promise(resolve => setTimeout(resolve, 1000));

            // PERFORMANS: RAF ile senkronize ekrana sığdır
            requestAnimationFrame(() => {
                this.ekranaSigdir(this);
            });

            // PERFORMANS: Gereksiz emit çağrılarını throttle et
            this._startAnimation();

            const bParam = this.BAcisi.userData['FikoParametreler'][0];
            new TWEEN.Tween(bParam)
                .to({ degeri: 0 }, 1000)
                .onUpdate(() => {
                    bParam.degisti(bParam.degeri);
                    // PERFORMANS: Emit'i animasyon döngüsüne al
                }).easing(TWEEN.Easing.Quadratic.Out).onComplete(() => {
                    const cParam = this.CAcisi.userData['FikoParametreler'][0];
                    new TWEEN.Tween(cParam)
                        .to({ degeri: 0 }, 1000)
                        .onUpdate(() => {
                            cParam.degisti(cParam.degeri);
                            // PERFORMANS: Emit'i animasyon döngüsüne al
                        }).easing(TWEEN.Easing.Quadratic.Out).onComplete(() => {
                            this.anaGosterim?.surekliCizIptal();
                            this._stopAnimation();
                        })
                        .start()
                })
                .start()

        }, 1000);


    }

    hazirla() {

    }

    guncelle() {

        // /** NOT: Kutu Sıfıra Göre Kaydırılıyor */
        // this.anaGosterim.ciz();
    }

    sunumId: any = null;
    aktifKonum = 0;
    simuleEt() {
        if (this.sunumId) return;

        if (this.sunumId) clearInterval(this.sunumId)
        if (this.kaynakca.konumlar.liste.length < 0) {
            return
        }


        // setTimeout(() => {
        // this.anaGosterim.surekliCiz();

        for (let i = 0; i < this.cizimler.userData.FikoParametreler.length; i++) {
            const element = this.cizimler.userData.FikoParametreler[i];
            element.degeri = element.ayar.maks
            new TWEEN.Tween(element)
                .to({ degeri: element.ayar.min }, 3000)
                .onUpdate(() => {
                    // this.anaGosterim.aktifKamera.updateProjectionMatrix()
                    element.degisti(element.degeri)
                    this.anaGosterim.FikoYT.degisti.emit();
                    // this.anaGosterim.ciz();
                }).easing(TWEEN.Easing.Quadratic.Out).yoyo(true).repeat(3).onComplete(() => {
                    // this.anaGosterim.surekliCizIptal();
                })
                .start()
        }


        // }, 3000)
    }

    carpmaKontrol() {
        if (this.aktifKonum < this.kaynakca.konumlar.liste.length) {
            this.aktifKonum = 1
        }
        this.sunumId = setInterval(() => {
            if (this.aktifKonum >= this.kaynakca.konumlar.liste.length) {
                this.aktifKonum = 1
                clearInterval(this.sunumId)
                this.sunumId = null;
            }
            this.kaynakca.konumlar.liste[this.aktifKonum].git();
            this.aktifKonum += 1
        }, 3000);

        this.updateMatrixWorld();
        this.updateWorldMatrix(true, true);

        var raycaster = new THREE.Raycaster();
        var intersects = raycaster.intersectObjects([this.boruSurucu.cizim, this.zEksen.cizim], false);

        // Debug: intersects
    }

    ekranaSigdir(obj: THREE.Object3D) {
        const geometriler: THREE.BufferGeometry[] = [];

        // PERFORMANS: Tek geçişte geometri topla
        obj.traverse((elm: any) => {
            if (elm.type === "FikoCizimYalin") {
                const mesh = (elm as FikoCizimYalin).children[0] as THREE.Mesh;
                if (mesh?.geometry) {
                    geometriler.push(mesh.geometry);
                }
            }
        });

        if (geometriler.length === 0) {
            return;
        }

        // PERFORMANS: Geometri merge işlemi sadece gerekirse
        const buffers = geometriler.length === 1
            ? geometriler[0]
            : BufferGeometryUtils.mergeGeometries(geometriler);

        if (!buffers) {
            return;
        }

        buffers.computeBoundingSphere();

        const boundingSphere = buffers.boundingSphere;
        if (!boundingSphere) return;

        const canvas = this.anaGosterim.canvas.nativeElement;
        const aspect = canvas.clientWidth / canvas.clientHeight;

        // PERFORMANS: Inline hesaplamalar - temp obje yaratma yok
        const yakinlik = aspect > 1.0
            ? canvas.clientHeight / (boundingSphere.radius * 2)
            : canvas.clientWidth / (boundingSphere.radius * 2);

        const hedefPoz = boundingSphere.center;

        // PERFORMANS: Reusable temp vektörler kullan
        this._tempVec3_1.copy(this.anaGosterim.aktifKontrol.target);
        this._tempVec3_2.copy(this.anaGosterim.aktifKamera.position);

        const yeniYonPoz = this._tempVec3_1.sub(hedefPoz);
        const tweenPos = this._tempVec3_2.sub(yeniYonPoz);

        // PERFORMANS: Tek TWEEN grubu - paralel animasyon
        const camTween = new TWEEN.Tween(this.anaGosterim.aktifKamera)
            .to({
                zoom: yakinlik * 0.7,
                position: { x: tweenPos.x, y: tweenPos.y, z: tweenPos.z }
            }, 500)
            .onUpdate(() => {
                this.anaGosterim.aktifKamera.updateProjectionMatrix();
            })
            .easing(TWEEN.Easing.Quadratic.Out);

        const ctrlTween = new TWEEN.Tween(this.anaGosterim.aktifKontrol)
            .to({ target: { x: hedefPoz.x, y: hedefPoz.y, z: hedefPoz.z } }, 500)
            .onUpdate(() => {
                this.anaGosterim.aktifKontrol.update();
            })
            .easing(TWEEN.Easing.Quadratic.Out);

        // PERFORMANS: Aynı anda başlat
        camTween.start();
        ctrlTween.start();
    }


    async relativeZoom(offsetZoom = 0.5, zaman = 1000) {
        return new Promise<boolean>((resolve) => {
            const yakinlik = this.anaGosterim.aktifKamera.zoom;

            new TWEEN.Tween(this.anaGosterim.aktifKamera)
                .to({ zoom: yakinlik * (1 + offsetZoom) }, zaman)
                .onUpdate(() => {
                    this.anaGosterim.aktifKamera.updateProjectionMatrix();
                })
                .easing(TWEEN.Easing.Quadratic.Out)
                .onComplete(() => {
                    resolve(true);
                })
                .start();
        });
    }

    // PERFORMANS: RAF tabanlı animasyon döngüsü - emit throttling
    private _startAnimation() {
        if (this._isAnimating) return;
        this._isAnimating = true;

        const animationLoop = () => {
            if (!this._isAnimating) return;

            // PERFORMANS: Tek emit per frame - batched updates
            this.anaGosterim?.FikoYT.degisti.emit();

            this._rafId = requestAnimationFrame(animationLoop);
        };

        this._rafId = requestAnimationFrame(animationLoop);
    }

    private _stopAnimation() {
        this._isAnimating = false;
        if (this._rafId !== null) {
            cancelAnimationFrame(this._rafId);
            this._rafId = null;
        }
        // Son güncelleme
        this.anaGosterim?.FikoYT.degisti.emit();
    }
}